"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
var _style = require("webmotors-react-pj/webinput/text/style");
var _validation = _interopRequireDefault(require("webmotors-react-pj/webinput/text/validation"));
var _mask = require("webmotors-react-pj/webinput/text/mask");
var _customAttributes = _interopRequireDefault(require("webmotors-react-pj/webinput/custom-attributes"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = (0, _react.forwardRef)((props, ref) => {
  const {
    type = 'text',
    description = '',
    placeholder = '',
    disabled,
    onInput,
    onFocus,
    onBlur,
    messageError,
    messageSuccess,
    value: valueInput = '',
    required,
    iconLeft,
    iconLeftEvent,
    iconRight,
    iconRightEvent,
    equal,
    min,
    max,
    maxLength,
    minLength,
    innerRef,
    message,
    fnrule,
    mask,
    dataQA
  } = props;
  const inputRef = ref || (0, _react.useRef)(innerRef);
  const iconPasswordToggle = '/assets/img/icons/eye.svg';
  const inputIsPassword = type === 'password' || type === 'password-weakened';
  const [active, setActive] = (0, _react.useState)(false);
  const [focus, setFocus] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)(valueInput);
  const [readonly, setReadonly] = (0, _react.useState)(true);
  const [iconSrcLeft, setIconSrcLeft] = (0, _react.useState)(iconLeft);
  const [iconSrcRight, setIconSrcRight] = (0, _react.useState)(inputIsPassword ? iconPasswordToggle : iconRight);
  const [descript, setDescript] = (0, _react.useState)(description);
  const [inputType, setInputType] = (0, _react.useState)(inputIsPassword ? 'password' : 'text');
  const propsCustom = (0, _customAttributes.default)(props, 'onBlur|onFocus|onInput|placeholder|value|required');
  const handleMask = () => {
    const typeMask = (0, _mask.getMask)(type, mask);
    const {
      current
    } = inputRef;
    if (typeMask) {
      (0, _mask.setMask)({
        input: current,
        mask: typeMask,
        initialValue: value
      });
      setValue(current.value);
    }
  };
  const handleFormat = () => {
    const {
      current
    } = inputRef;
    if (type === 'email') {
      current.value = value.toLowerCase();
    }
    if (value.length > maxLength) {
      current.value = value.substring(0, maxLength);
    }
  };
  const handleInput = e => {
    const {
      value
    } = e.target;
    let valueFormat = value;
    if (type === 'email') {
      const {
        current: input
      } = inputRef;
      const {
        value
      } = input;
      valueFormat = value.toLowerCase();
    }
    setValue(valueFormat);
    onInput && onInput(e);
  };
  const handleFocus = e => {
    setActive(true);
    setFocus(true);
    setReadonly(false);
    onFocus && onFocus(e);
  };
  const handleBlur = e => {
    e.persist();
    const valueEmpty = value.length === 0;
    setActive(!valueEmpty);
    setFocus(false);
    (0, _validation.default)({
      value,
      type,
      min,
      max,
      required,
      equal,
      message,
      fnrule
    }).then(f => {
      const {
        success,
        data
      } = f;
      const dataError = !success && (messageError || data);
      const dataSuccess = success && (messageSuccess || description);
      renderIconRightType(success);
      setError(!success);
      setDescript(!success ? dataError : dataSuccess);
      onBlur && onBlur(e);
    });
  };
  const handleClickIconLeft = () => {
    iconLeftEvent && iconLeftEvent();
  };
  const handleClickIconRight = () => {
    setInputType(prevType => {
      if (inputIsPassword) {
        return prevType === 'password' ? 'text' : 'password';
      }
      return 'text';
    });
    iconRightEvent && iconRightEvent();
  };
  const renderIconError = success => {
    setIconSrcRight(!success ? '/assets/img/icons/alert-2.svg' : iconRight);
  };
  const renderIconRightType = success => {
    inputIsPassword ? setIconSrcRight(iconPasswordToggle) : renderIconError(success);
  };
  const renderIconLeft = () => iconSrcLeft && _react.default.createElement(_img.default, {
    className: "icon icon-left",
    src: iconSrcLeft,
    onClick: () => handleClickIconLeft()
  });
  const renderIconRight = () => iconSrcRight && _react.default.createElement(_img.default, {
    className: "icon icon-right",
    src: iconSrcRight,
    onClick: () => handleClickIconRight()
  });
  const handleActive = () => {
    if (value && value.length !== 0) {
      setActive(true);
    }
  };
  (0, _react.useEffect)(() => {
    handleActive();
    handleMask();
  }, []);
  (0, _react.useEffect)(() => {
    handleFormat();
    handleActive();
    handleMask();
  }, [value]);
  (0, _react.useEffect)(() => {
    setValue(valueInput);
  }, [valueInput]);
  (0, _react.useEffect)(() => {
    setDescript(messageError);
    setError(messageError && Boolean(messageError.length));
  }, [messageError]);
  (0, _react.useEffect)(() => {
    setDescript(messageSuccess);
  }, [messageSuccess]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_style.StyleLabel, {
    disabled: disabled,
    active: active,
    focus: focus,
    error: error,
    "data-input-error": error,
    "data-qa": dataQA,
    onTouchStart: e => handleFocus(e)
  }, renderIconLeft(), _react.default.createElement(_style.StylePlaceholder, {
    active: active,
    focus: focus,
    error: error,
    iconLeft: iconSrcLeft
  }, placeholder), _react.default.createElement(_style.StyleInput, (0, _extends2.default)({}, propsCustom, {
    error: error,
    active: active,
    type: inputType,
    value: value,
    ref: inputRef,
    readOnly: readonly,
    onInput: e => handleInput(e),
    onFocus: e => handleFocus(e),
    onBlur: e => handleBlur(e),
    onTouchStart: e => handleFocus(e)
  })), renderIconRight()), _react.default.createElement(_style.StyleDescript, {
    id: "descriptionMessageText"
  }, descript));
});